import React, { useRef } from "react"

import { graphql } from "gatsby"
import { KeyFigureV2FieldsFragment } from "../../../../../../../graphql-types"

import * as styles from "./key-figure-v2.module.scss"

type KeyFigureV2Props = {
  data: KeyFigureV2FieldsFragment
  keyFigureAmount: number
  isVisible?: boolean
}

const KeyFigureV2: React.FC<KeyFigureV2Props> = ({ data, keyFigureAmount, isVisible = true }) => {
  const refContainer = useRef(null)

  return (
    <section 
      className={`${styles.container} ${!isVisible ? styles.hidden : ''}`}
      style={{ backgroundColor: data.backgroundColor?.hex ?? "#FFFF74"}}
      ref={refContainer}
    >
      <div style={{color: data.textColor?.hex ?? "#162B44", margin: data.description ? "0px 8%" : "auto 8%" }}>
        <p className={ data.description ? styles.value : styles.valueOnly }>{data.value}</p>
        <p className={styles.description}>{data.description}</p>
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment KeyFigureV2Fields on DatoCmsKeyFigureV2 {
    __typename
    id
    value
    description
    textColor {
      hex
    }
    backgroundColor {
      hex
    }
  }
`

export default KeyFigureV2
